import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmExperienceFormEditRoute: InvariantJiraRoute = {
	name: 'csm-experience-form-edit',
	path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/forms/:formId',
	exact: true,
};
